import { render } from "./SectionAnnouncementPage.vue?vue&type=template&id=16f3bcd4&scoped=true"
import script from "./SectionAnnouncementPage.vue?vue&type=script&lang=js"
export * from "./SectionAnnouncementPage.vue?vue&type=script&lang=js"

import "./SectionAnnouncementPage.vue?vue&type=style&index=0&id=16f3bcd4&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f3bcd4"]])

export default __exports__